import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Divider from 'components/Divider';
import ButtonDeprecated from 'components/ButtonDeprecated';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import Icon from 'components/Icon';

import CoachingBillingStripe from 'coaching/components/CoachingBillingView/CoachingBillingStripe';
import CoachingStripeContainer from 'coaching/components/CoachingStripeContainer';
import { coachingBillingViewPrefix } from 'coaching/components/CoachingBillingView/CoachingBillingView';

import { CoachingbillingCardDetailType } from './types';

type Props = {
  onClose: () => void;
  cardDetail?: CoachingbillingCardDetailType;
};

export default function CoachingBillingCardSidebar(props: Props) {
  const { onClose, cardDetail } = props;
  return (
    <>
      <BoxBody size="xsmall">
        <MediaObject figure="right">
          <Text color="graphite">Update payment</Text>
          <ButtonDeprecated eventKey={`${coachingBillingViewPrefix}.coaching_billing_sidebar_card.exit_close.click`} level="icon" color="chalkboard" onClick={onClose}>
            <Icon name="x" />
          </ButtonDeprecated>
        </MediaObject>
      </BoxBody>
      <Divider size="flush" />
      <CoachingStripeContainer>
        <CoachingBillingStripe onCloseSideBar={onClose} cardDetail={cardDetail} />
      </CoachingStripeContainer>
    </>
  );
}
